import { render, staticRenderFns } from "./Collect8.vue?vue&type=template&id=cb81c920&scoped=true&lang=pug&"
import script from "./Collect8.vue?vue&type=script&lang=ts&"
export * from "./Collect8.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb81c920",
  null
  
)

export default component.exports